import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { Icon as o } from "../../../components/Icon/index.js";
import { DealImageBadgeContainer as m, DealImageBadgeIcon as n, DealImageBadgeText as i } from "./style.js";
import { TriangleExclamation as t } from "@pelando/fontawesome/icons";
function I({ label: a }) {
  return /* @__PURE__ */ r(m, { children: [
    /* @__PURE__ */ e(n, { children: /* @__PURE__ */ e(o, { icon: t }) }),
    /* @__PURE__ */ e(i, { children: a })
  ] });
}
export {
  I as DealImageBadge
};
